module.exports = __webpack_public_path__ + "img/ico12.64f30a74.svg";